<template>
  <b-modal
    :hide-footer="true"
    :title="`Edição: ${item.descricao}`"
    centered
    size="md"
    id="show-subtipos"
  >
    <div v-if="load" class="row p-3">
      <div class="p-3">
        <loading-animation
          :active.sync="load"
          :is-full-page="false"
          :opacity="1"
          color="#5895FF"
        />
      </div>
    </div>
    <div v-else class="row">
      <form-input-group
        @submit="editar(item)"
        mt="0"
        label="Descrição do tipo"
        v-model="item.descricao"
        icon-btn="mdi mdi-check"
        btn-class="btn btn-success btn-sm float-right px-2 mb-0"
        v-if="verifyOrigin(item.origem)"
      />
      <div class="col-12" v-else>
        <div class="alert alert-info" role="alert">
          O tipo <b>{{ item.descricao }}</b> é padrão do sistema e não pode ser
          editado. Apenas tipos e subtipos que não são padrões podem ser
          editados.
        </div>
      </div>

      <h5 class="font-weight-bold col-12 mt-3">Subtipos</h5>
      <form-input-group
        @submit="inserir"
        mt="0"
        placeholder="Digite o subtipo que deseja inserir"
        v-model="subtipo"
        icon-btn="mdi mdi-check"
        btn-class="btn btn-success btn-sm float-right px-2 mb-0"
      />
      <div class="col-12" v-if="item.subtipos">
        <table
          v-if="item.subtipos.length > 0"
          class="table table-bordered bg-white table-sm"
        >
          <thead class="thead-light">
            <tr>
              <th>DESCRIÇÃO</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(sub, index) in item.subtipos" :key="sub.id">
              <td v-if="verifyOrigin(item.origem)">
                <form-input class="px-0" mt="0" v-model="sub.descricao" />
              </td>
              <td colspan="2" v-else>
                <form-input
                  class="px-0"
                  mt="0"
                  v-model="sub.descricao"
                  disabled
                />
              </td>
              <td v-if="verifyOrigin(item.origem)">
                <button
                  :title="$t('Excluir Subtipo')"
                  class="btn btn-danger btn-sm float-right px-2 mb-0"
                  @click="excluir(sub, index)"
                >
                  <i class="mdi mdi-close" />
                </button>
                <button
                  :title="$t('Editar Subtipo')"
                  class="btn btn-success btn-sm float-right px-2 mb-0"
                  @click="editar(sub)"
                >
                  <i class="mdi mdi-check" />
                </button>
              </td>
            </tr>
          </tbody>
        </table>
        <div v-else>
          <h4 class="text-secondary">
            <i class="mdi mdi-24px mdi-alert-decagram-outline"></i>
            Esse tipo ainda não possui subtipos.
          </h4>
        </div>
      </div>
    </div>
  </b-modal>
</template>
<script>
export default {
  props: ["item", "modulo"],
  data() {
    return { load: false, subtipo: "" };
  },
  methods: {
    verifyOrigin(origem) {
      return origem == "CADASTRADO";
    },
    inserir() {
      if (this.subtipo != "") {
        this.load = true;
        axios
          .post("api/dashboard/admin/tipos", {
            descricao: this.subtipo,
            tipo_pai: this.item.id,
            type: this.item.type,
          })
          .then((response) => {
            this.$snack.success({
              button: false,
              text: "Subtipo cadastrado com sucesso.",
            });
            this.item.subtipos = response.data.data;
            this.subtipo = "";
            this.load = false;
          });
      }
    },
    excluir(item, index) {
      this.load = true;
      axios
        .get(`api/dashboard/admin/excluir/tipo/${item.id}/${this.modulo}`)
        .then((response) => {
          this.$emit("reload");
          this.$snack.success({
            button: false,
            text: "Excluído com sucesso.",
          });
          this.item.subtipos.splice(index, 1);
          this.load = false;
        });
    },
    editar(item) {
      this.load = true;
      axios
        .post("api/dashboard/admin/update/tipo", {
          id: item.id,
          descricao: item.descricao,
        })
        .then((response) => {
          this.$emit("reload");
          this.$snack.success({
            button: false,
            text: "Atualizado com sucesso.",
          });
          this.load = false;
        });
    },
  },
};
</script>
